import * as types from '@/store/types'
export default {
    loadUser(context, payload) {
        payload['currentPassword'] = ''
        payload['newPassword'] = ''
        payload['newPasswordRepeat'] = ''
        context.user = payload
        context.loaded = true
    },
    setUser: (context, payload) => {
        context.user = payload.response.data
    },
    deletePasswordsInForm: (context) => {
        let user = Object.assign({}, context.user)
        user['currentPassword'] = ''
        user['newPassword'] = ''
        user['newPasswordRepeat'] = ''
        context.user = user
    },
    setLoaded: (context, value) => {
        context.loaded = value
    },
    loadVkGroups: (context, payload) => {
        context.vkGroups = payload.response.items // еще есть свойство count
        context.loadedVkGroups = true
    }
}
